import React from 'react';

export interface StripItem {
  v: number | string;
  k: string;
  p?: string;
  cls?: 'visited' | 'gold' | 'bad';
}

/** The KPI row — each number stacked over its label, % beside the number.
 *  The one renderer behind every strip; `visited` is the headline (site
 *  visits lead every page), `gold` next, the rest quieter. */
const NumberStrip: React.FC<{ items: StripItem[]; className?: string }> = ({ items, className = '' }) => (
  <div className={`flex flex-wrap gap-y-4 ${className}`}>
    {items.map(({ v, k, p, cls }, i) => (
      <div key={k} className={`pr-7 mr-7 min-w-[72px] ${i < items.length - 1 ? 'border-r border-charcoal/10' : ''}`}>
        <div className="flex items-baseline gap-1.5">
          <span className={`num font-display font-semibold leading-none tracking-tight ${
            cls === 'visited' ? 'text-forest text-[34px]'
              : cls === 'gold' ? 'text-amber-ink text-[28px]'
              : cls === 'bad' ? 'text-brick text-[22px]'
              : 'text-charcoal text-[22px]'
          }`}>{v}</span>
          {p && <span className="num text-[12px] font-medium text-graphite">{p}</span>}
        </div>
        <div className={`mt-1.5 text-[11px] uppercase tracking-[0.06em] font-semibold ${
          cls === 'visited' ? 'text-forest' : cls === 'gold' ? 'text-amber-ink' : cls === 'bad' ? 'text-brick' : 'text-graphite'
        }`}>{k}</div>
      </div>
    ))}
  </div>
);

export default NumberStrip;
